module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/clan_quests_top.72839b68.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/clan_quests_top.png
// module id = 2960
// module chunks = 11